<script setup>
	import { defineProps, computed } from 'vue'

	const props = defineProps(['title', 'icon'])

	const reversedLetters = computed(() => {
	  return props.title.split('').reverse()
	})

</script>

<template>
	<div class="clasification">
		<div>
			<img 
			  v-lazy="{ 
			    src: icon, 
			    loading: 'img/image_loader.gif', 
			    error: 'img/no_image.png' }" 
			    alt="Item Icon"
			 />
		</div>
		<h3>
			<span v-for="(letter, index) in reversedLetters" :key="index">
	        	{{ letter }}
	      	</span>
		</h3>
		
	</div>
</template>

<style scoped>
	/*
    **CLASIFICATION BUTTONS
    */
    .clasification {
        @apply mx-2 pt-2 pb-4 px-1 border-2 border-zinc-200/50 dark:border-zinc-900/50 rounded-[40px] flex items-center shadow-md shadow-zinc-200/50 dark:shadow-zinc-900/50 transition-all duration-200 ease-linear flex flex-col;
        /*min-w-[80px] h-[50px]*/
    }

    .clasification > div {
        @apply w-10 h-10 mb-3 bg-white dark:bg-zinc-700 shadow-md shadow-zinc-200/50 dark:shadow-zinc-900/50 rounded-full relative; 
        /*w-[40px] h-[40px]**/
    }

    .clasification > div img {
        @apply absolute left-[50%] top-[50%] w-[60%] h-[60%] translate-x-[-50%] translate-y-[-50%] object-cover opacity-[.50] dark:invert;
    }

    .clasification h3 {
        /*@apply font-thin text-sm px-2 grow text-nowrap*/
        @apply grid grid-cols-1;
    }

    .clasification h3 span {
        @apply font-thin text-sm w-[12px] h-[12px] rotate-[-90deg] relative left-[-6px]; /**/
    }

    .clasification.active {
        @apply bg-[#FF7043] text-white border-[#FF7043];
    }
</style>